import LogRocket from 'logrocket'

export const logRocketTrack = (event) => LogRocket.track(event)

export const logRocketIdentify = (id) => {
  LogRocket.identify(id)
}

export const logRocketCaptureError = (err) => LogRocket.captureException(err)
